import React from 'react';
import PropTypes from 'prop-types';
import RadioButton from '../../../../../../shared/components/RadioButton/RadioButton';

const MethodOfPayment = (props) => {
  const _checkboxOnChange = (option) => {
    props.optionChanged(option);
  };

  return (
    <div className='row equal methodOfPayment'>
      <div className='col-xs-12 col-sm-6 paymentSelection'>
        <form>
          <p className='title'>Method of Payment</p>
          <RadioButton
            title='By Card on File'
            checked={props.checked === props.options[0]}
            onChange={_checkboxOnChange}
            disabled={props.onFileDisabled}
            option={props.options[0]}
          />
          <RadioButton
            title='Use a New Card'
            checked={props.checked === props.options[1]}
            onChange={_checkboxOnChange}
            option={props.options[1]}
          />
        </form>
      </div>
      <div className='col-xs-12 col-sm-6 finePrint'>
        <p className='descTop'>Your credit card will be charged after successful generation of your export.</p>
      </div>
    </div>
  );
};

MethodOfPayment.propTypes = {
  optionChanged: PropTypes.func,
  onFileDisabled: PropTypes.bool,
  options: PropTypes.array,
  checked: PropTypes.string,
};

export default MethodOfPayment;



// WEBPACK FOOTER //
// ./modules/DataExports/components/PurchaseData/children/MethodOfPayment/MethodOfPayment.js